import { CheckOutlined, DeleteOutlined, PlusOutlined, PoweroffOutlined } from "@ant-design/icons";
import { message, Popconfirm, Space, Table, Tooltip } from "antd";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, ModalItem, SegmentedItem, SelectItem, TagItem } from "../../../../Components/Items";
import { colorPaleta } from "../../../../Components/TagItem";
import { formatoDinero, postCobro } from "./cobroBiwoTextos";

const OPCIONES_BLOQUEO = [
    { value: "default", label: "Según catálogo" },
    { value: "si", label: "Bloquear" },
    { value: "no", label: "No bloquear" },
];
const CUADRO = { borderRadius: 8, padding: "10px 12px", width: 230, maxWidth: "100%", boxSizing: "border-box" };
const TITULO = { fontSize: 14, fontWeight: 600, color: "#333", margin: "16px 0 8px" };

class ModalComplementosEmpresa extends Component {
    state = { loading: false, modulos: [], cobroActivo: false, paquetesIa: [], paqueteIaId: null, borradores: {}, vista: "visual", calculo: null, combos: [] };

    componentDidUpdate(prevProps) {
        if (this.props.empresa && this.props.empresa !== prevProps.empresa) this.consultar();
    }

    consultar = () => {
        this.setState({ loading: true });
        postCobro(axios, "selectComplementosEmpresa", { empresaId: this.props.empresa._id }, this.props.headersToken).then((data) => {
            if (data.success !== 2) {
                this.setState({ loading: false });
                return message.error(data.message || "Error al consultar los complementos");
            }
            this.setState({ loading: false, modulos: data.data, cobroActivo: data.cobroActivo, paquetesIa: data.paquetesIa, paqueteIaId: data.paqueteIaId, borradores: {} });
        });
        postCobro(axios, "selectCombosCobro", {}, this.props.headersToken).then((data) => {
            if (data.success === 2) this.setState({ combos: data.data });
        });
        postCobro(axios, "calcularCobroEmpresa", { empresaId: this.props.empresa._id }, this.props.headersToken).then((data) => {
            this.setState({ calculo: data.success === 2 ? data.data : null });
        });
    };

    guardar = (modulo, cambios) => {
        const actual = { ...this.valores(modulo), ...cambios };
        if (actual.activo && modulo.concepto?.tipoPrecio === "niveles" && !actual.nivelId) {
            this.setState((s) => ({ borradores: { ...s.borradores, [modulo.clave]: actual } }));
            return message.info("Selecciona el paquete para activarlo");
        }
        if (actual.activo && modulo.clave === "claude" && modulo.concepto?.tipoPrecio !== "niveles" && !actual.paqueteIaId) {
            this.setState((s) => ({ borradores: { ...s.borradores, [modulo.clave]: actual } }));
            return message.info("Selecciona el paquete de IA para activarla");
        }
        this.setState({ loading: true });
        postCobro(
            axios,
            "guardarComplementoEmpresa",
            {
                empresaId: this.props.empresa._id,
                clave: modulo.clave,
                activo: actual.activo,
                nivelId: actual.nivelId,
                paqueteIaId: actual.paqueteIaId,
                bloquearAlExceder: actual.bloqueo === "si" ? true : actual.bloqueo === "no" ? false : null,
            },
            this.props.headersToken
        ).then((data) => {
            if (data.success === 2) {
                message.success(data.message);
                this.consultar();
            } else {
                this.setState({ loading: false });
                message.error(data.message || "No se pudo guardar");
            }
        });
    };

    valores(modulo) {
        const borrador = this.state.borradores[modulo.clave];
        if (borrador) return borrador;
        const bloquear = modulo.contratacion?.bloquearAlExceder;
        return {
            activo: modulo.activo,
            nivelId: modulo.contratacion?.nivelId || undefined,
            paqueteIaId: modulo.clave === "claude" ? this.state.paqueteIaId || undefined : undefined,
            bloqueo: bloquear === true ? "si" : bloquear === false ? "no" : "default",
        };
    }

    selectorPaquete(m, activarAlElegir = false) {
        const v = this.valores(m);
        if (m.concepto?.tipoPrecio === "niveles") {
            const siguiente = m.contratacion?.nivelSiguienteId && m.concepto.niveles.find((n) => n._id === m.contratacion.nivelSiguienteId);
            return (
                <>
                <SelectItem
                    size="small"
                    style={{ width: "100%", minWidth: 180 }}
                    placeholder="Selecciona paquete"
                    value={v.nivelId}
                    onChange={(nivelId) => (activarAlElegir ? this.guardar(m, { nivelId, activo: true }) : v.activo ? this.guardar(m, { nivelId }) : this.setState((s) => ({ borradores: { ...s.borradores, [m.clave]: { ...v, nivelId } } })))}
                    options={m.concepto.niveles
                        .filter((n) => n.activo !== false || n._id === v.nivelId)
                        .map((n) => ({ value: n._id, label: `${n.nombre} · ${formatoDinero(n.precio)}` }))}
                />
                {siguiente && <TagItem naranja style={{ marginTop: 4 }}>Cambia a {siguiente.nombre} el {moment(m.contratacion.fechaCambio).format("DD/MM/YYYY")}</TagItem>}
                </>
            );
        }
        if (m.clave === "claude" && m.concepto?.tipoPrecio !== "niveles") {
            return (
                <SelectItem
                    size="small"
                    style={{ width: "100%", minWidth: 180 }}
                    placeholder="Paquete de IA"
                    value={v.paqueteIaId}
                    onChange={(paqueteIaId) => this.guardar(m, { paqueteIaId, activo: activarAlElegir || v.activo })}
                    options={this.state.paquetesIa.map((p) => ({ value: p._id, label: p.nombre }))}
                />
            );
        }
        return m.concepto ? formatoDinero(m.concepto.precio) : "Sin precio en catálogo";
    }

    activarCombo = (combo) => {
        this.setState({ loading: true });
        postCobro(axios, "activarComboEmpresa", { empresaId: this.props.empresa._id, comboId: combo._id }, this.props.headersToken).then((data) => {
            if (data.success === 2) {
                message.success(data.message);
                this.consultar();
            } else {
                this.setState({ loading: false });
                message.error(data.message || "No se pudo activar el combo");
            }
        });
    };

    precioPartida(partida) {
        if (!partida) return null;
        return (
            <>
                <div>{formatoDinero(partida.importeCompleto)} completo sin IVA</div>
                {partida.dias && (
                    <div style={{ fontSize: 12 }}>
                        Este periodo: <b>{formatoDinero(partida.importe)}</b> ({partida.dias.cobrados} de {partida.dias.periodo} días)
                    </div>
                )}
            </>
        );
    }

    cuadroModulo(m, partida, detalleCombo = null) {
        const deBaja = !m.activo;
        return (
            <div
                key={m.clave}
                style={{
                    ...CUADRO,
                    background: deBaja ? "#fafafa" : "white",
                    border: "1px solid #f0f0f0",
                    borderLeft: `4px solid ${deBaja ? "#bfbfbf" : colorPaleta("cyan")}`,
                    boxShadow: deBaja ? "none" : "0 2px 8px rgba(0,0,0,0.06)",
                }}
            >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 6, marginBottom: 4 }}>
                    <span style={{ fontWeight: 600, color: deBaja ? "#8c8c8c" : "#333" }}>{m.nombre}</span>
                    {!deBaja && (
                        <Popconfirm title={`¿Desactivar ${m.nombre}? Se cobra hasta el corte`} onConfirm={() => this.guardar(m, { activo: false })} okText="Sí" cancelText="No">
                            <Tooltip title="Desactivar">
                                <ButtonItem size="small" danger icon={<DeleteOutlined />} />
                            </Tooltip>
                        </Popconfirm>
                    )}
                </div>
                {deBaja && <TagItem gris>De baja · se cobra hasta el corte</TagItem>}
                {!deBaja && (m.concepto?.tipoPrecio === "niveles" || m.clave === "claude") && <div style={{ margin: "4px 0" }}>{this.selectorPaquete(m)}</div>}
                {detalleCombo ? (
                    <>
                        <div>{formatoDinero(detalleCombo.precioCompleto)} unitario sin IVA</div>
                        {detalleCombo.cobroPeriodo !== detalleCombo.precioCompleto && (
                            <div style={{ fontSize: 12 }}>Este periodo: {formatoDinero(detalleCombo.cobroPeriodo)}</div>
                        )}
                    </>
                ) : partida ? (
                    this.precioPartida(partida)
                ) : m.concepto && !deBaja ? (
                    <>
                        <TagItem naranja>Activo, no se está cobrando</TagItem>
                        <div style={{ fontSize: 12, margin: "4px 0" }}>
                            Precio de catálogo:{" "}
                            {m.concepto.tipoPrecio === "niveles"
                                ? `desde ${formatoDinero(Math.min(...m.concepto.niveles.filter((n) => n.activo !== false).map((n) => n.precio)))} · elige el paquete para cobrarlo`
                                : `${formatoDinero(m.concepto.precio)} sin IVA`}
                        </div>
                        {m.concepto.tipoPrecio !== "niveles" && m.clave !== "claude" && (
                            <Popconfirm title={`¿Empezar a cobrar ${m.nombre} desde hoy?`} onConfirm={() => this.guardar(m, { activo: true })} okText="Sí" cancelText="No">
                                <ButtonItem verde size="small" icon={<CheckOutlined />}>Empezar a cobrar</ButtonItem>
                            </Popconfirm>
                        )}
                    </>
                ) : (
                    <TagItem gris>Sin precio en catálogo</TagItem>
                )}
                {m.incluye?.length > 0 && (
                    <div style={{ fontSize: 11, color: "#8c8c8c", marginTop: 4 }}>Habilita: {m.incluye.map((s) => `${s.nombre}${s.activo ? " ✓" : ""}`).join(", ")}</div>
                )}
            </div>
        );
    }

    renderVisual() {
        const { modulos, calculo, combos } = this.state;
        const porClave = new Map(modulos.map((m) => [m.clave, m]));
        const porConceptoId = new Map(modulos.filter((m) => m.concepto).map((m) => [String(m.concepto._id), m]));
        const partidas = calculo?.partidas || [];
        const combosCobrados = partidas.filter((p) => p.tipo === "combo");
        const sueltos = partidas.filter((p) => p.tipo === "concepto");
        const cobrados = new Set([...combosCobrados.flatMap((p) => p.claves || []), ...sueltos.map((p) => p.clave)]);
        const activosSinPrecio = modulos.filter((m) => m.activo && !cobrados.has(m.clave));
        const disponibles = modulos.filter((m) => !m.activo);
        const combosPorElegir = (combos || []).filter((k) => k.activo && !combosCobrados.some((p) => String(p.comboId) === String(k._id)));
        const titulo = (texto) => <div style={TITULO}>{texto}</div>;
        const mosaico = (t) => (
            <div key={t.titulo} style={{ flex: "1 1 170px", padding: "10px 14px", borderRadius: 8, backgroundColor: "white", border: "1px solid #f0f0f0", borderLeft: `4px solid ${t.color}`, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
                <div style={{ fontSize: 12, color: "#8c8c8c", fontWeight: 500 }}>{t.titulo}</div>
                <div style={{ fontSize: 20, fontWeight: 600, color: "#333" }}>{t.valor}</div>
            </div>
        );

        return (
            <>
                {calculo && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                        {mosaico({ titulo: `Este periodo · ${moment(calculo.periodo.inicio).format("DD/MM/YYYY")} – ${moment(calculo.periodo.fin).format("DD/MM/YYYY")}`, valor: formatoDinero(calculo.total), color: colorPaleta("cyan") })}
                        {mosaico({ titulo: "Precio completo (sin IVA)", valor: formatoDinero(partidas.reduce((s, p) => s + (p.importeCompleto || 0), 0)), color: colorPaleta("azul") })}
                        {calculo.totalLista > calculo.total && mosaico({ titulo: "Ahorra", valor: formatoDinero(calculo.totalLista - calculo.total), color: colorPaleta("verdeNatural") })}
                    </div>
                )}
                {titulo("Contratado")}
                <div style={{ display: "flex", flexWrap: "wrap", gap: 10, alignItems: "flex-start" }}>
                    {combosCobrados.map((p) => (
                        <div key={String(p.comboId)} style={{ border: `1px solid ${colorPaleta("cyan")}73`, borderLeft: `4px solid ${colorPaleta("cyan")}`, borderRadius: 8, padding: 10, background: `${colorPaleta("cyan")}0F`, maxWidth: "100%" }}>
                            <div style={{ marginBottom: 8 }}>
                                <TagItem cyan>Combo</TagItem><b>{p.nombre}</b>
                                {p.importeLista > p.importe && <TagItem verdeNatural style={{ marginLeft: 6 }}>Ahorra {formatoDinero(p.importeLista - p.importe)}</TagItem>}
                                {this.precioPartida(p)}
                            </div>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                                {(p.claves || []).map((clave) => porClave.get(clave) && this.cuadroModulo(porClave.get(clave), null, (p.detalle || []).find((d) => d.clave === clave)))}
                            </div>
                        </div>
                    ))}
                    {sueltos.map((p) => porClave.get(p.clave) && this.cuadroModulo(porClave.get(p.clave), p))}
                    {activosSinPrecio.map((m) => this.cuadroModulo(m, null))}
                    {partidas.length === 0 && activosSinPrecio.length === 0 && <span style={{ color: "#8c8c8c" }}>Sin complementos activos</span>}
                </div>
                {combosPorElegir.length > 0 && titulo("Combos disponibles")}
                <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                    {combosPorElegir.map((k) => (
                        <Popconfirm key={k._id} title={`¿Activar el combo ${k.nombre}?`} onConfirm={() => this.activarCombo(k)} okText="Sí" cancelText="No">
                            <div style={{ ...CUADRO, border: `1px dashed ${colorPaleta("cyan")}`, background: "white", cursor: "pointer" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 6, fontWeight: 600, color: "#333" }}><PlusOutlined style={{ color: colorPaleta("cyan") }} />{k.nombre}</div>
                                <div style={{ fontSize: 12 }}>{k.items.map((i) => `${porConceptoId.get(String(i.conceptoId))?.nombre || i.conceptoNombre}${i.nivelNombre ? ` ${i.nivelNombre}` : ""}`).join(" + ")}</div>
                                <div>
                                    {formatoDinero(k.precio)} completo sin IVA
                                    {k.ahorro > 0 && <TagItem verdeNatural style={{ marginLeft: 6 }}>Ahorra {formatoDinero(k.ahorro)}</TagItem>}
                                </div>
                            </div>
                        </Popconfirm>
                    ))}
                </div>
                {titulo("Disponibles")}
                <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                    {disponibles.map((m) => {
                        const conPaquete = m.concepto?.tipoPrecio === "niveles" || m.clave === "claude";
                        return (
                            <div
                                key={m.clave}
                                onClick={conPaquete ? undefined : () => this.guardar(m, { activo: true })}
                                style={{ ...CUADRO, border: "1px dashed #bfbfbf", background: "white", color: "#595959", cursor: conPaquete ? "default" : "pointer" }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: 6, fontWeight: 600, color: "#333" }}>{!conPaquete && <PlusOutlined style={{ color: "#8c8c8c" }} />}{m.nombre}</div>
                                {conPaquete ? (
                                    <div style={{ marginTop: 4 }}>{this.selectorPaquete(m, true)}</div>
                                ) : (
                                    <div style={{ fontSize: 12 }}>{m.concepto ? `${formatoDinero(m.concepto.precio)} sin IVA · clic para activar` : "Sin precio · clic para activar"}</div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </>
        );
    }

    render() {
        const empresa = this.props.empresa;
        return (
            <ModalItem
                visible={!!empresa}
                title={empresa ? `Complementos de ${empresa.nombreCompleto}` : ""}
                onCancel={this.props.onCancel}
                footer={null}
                destroyOnClose
                spinning={this.state.loading}
                width={1000}
            >
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", gap: 12, padding: "10px 14px", margin: "4px 0 12px", backgroundColor: "white", border: "1px solid #f0f0f0", borderRadius: 8 }}>
                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8, flex: "1 1 300px", minWidth: 0 }}>
                        {this.state.cobroActivo ? <TagItem verdeNatural style={{ margin: 0 }}>Cobro activo</TagItem> : <TagItem naranja style={{ margin: 0 }}>Sin cobro configurado</TagItem>}
                        <span style={{ fontSize: 12, color: "#595959" }}>
                            {this.state.cobroActivo ? "Se cobran y la empresa ya no puede cambiarlos" : "Los cambios solo prenden/apagan el módulo"}
                        </span>
                    </div>
                    <SegmentedItem options={[{ label: "Visual", value: "visual" }, { label: "Tabla", value: "tabla" }]} value={this.state.vista} onChange={(vista) => this.setState({ vista })} />
                </div>
                {this.state.vista === "visual" ? this.renderVisual() : (
                    <Table
                        size="small"
                        className="custom-small-table"
                        rowKey="clave"
                        pagination={false}
                        dataSource={this.state.modulos}
                        scroll={{ x: "max-content", y: 520 }}
                        columns={[
                            {
                                title: "Complemento",
                                width: 230,
                                filters: this.state.modulos.map((m) => ({ text: m.nombre, value: m.clave })),
                                onFilter: (valor, m) => m.clave === valor,
                                sorter: (a, b) => String(a.nombre || "").localeCompare(String(b.nombre || "")),
                                render: (m) => (
                                    <>
                                        <div>{m.nombre}</div>
                                        {m.incluye?.length > 0 && (
                                            <div style={{ fontSize: 11, color: "#8c8c8c" }}>
                                                Habilita (la empresa los activa): {m.incluye.map((s) => `${s.nombre}${s.activo ? " ✓" : ""}`).join(", ")}
                                            </div>
                                        )}
                                    </>
                                ),
                            },
                            {
                                title: "Estado",
                                width: 90,
                                filters: [{ text: "Activo", value: "activo" }, { text: "Inactivo", value: "inactivo" }],
                                onFilter: (valor, m) => (this.valores(m).activo ? "activo" : "inactivo") === valor,
                                render: (m) => (this.valores(m).activo ? <TagItem verdeNatural>Activo</TagItem> : <TagItem gris>Inactivo</TagItem>),
                            },
                            {
                                title: "Paquete",
                                render: (m) => this.selectorPaquete(m),
                            },
                            {
                                title: "Al exceder límite",
                                width: 160,
                                render: (m) =>
                                    m.unidadLimite && m.unidadLimite !== "consultas" && m.concepto?.tipoPrecio === "niveles" ? (
                                        <SelectItem
                                            size="small"
                                            style={{ width: 150 }}
                                            value={this.valores(m).bloqueo}
                                            disabled={!this.valores(m).activo}
                                            onChange={(bloqueo) => this.guardar(m, { bloqueo })}
                                            options={OPCIONES_BLOQUEO}
                                        />
                                    ) : (
                                        "—"
                                    ),
                            },
                            {
                                title: "Contratado desde",
                                width: 130,
                                sorter: (a, b) => (a.contratacion ? moment(a.contratacion.fechaInicio).valueOf() : 0) - (b.contratacion ? moment(b.contratacion.fechaInicio).valueOf() : 0),
                                render: (m) => (m.contratacion ? moment(m.contratacion.fechaInicio).format("DD/MM/YYYY") : "—"),
                            },
                            {
                                title: "Acciones",
                                key: "acciones",
                                width: 80,
                                align: "center",
                                render: (m) => (
                                    <Space>
                                        {this.valores(m).activo ? (
                                            <Popconfirm title={`¿Desactivar ${m.nombre}? Se cobra hasta el corte`} onConfirm={() => this.guardar(m, { activo: false })} okText="Sí" cancelText="No">
                                                <Tooltip title="Desactivar">
                                                    <ButtonItem size="small" danger icon={<PoweroffOutlined />} />
                                                </Tooltip>
                                            </Popconfirm>
                                        ) : (
                                            <Tooltip title="Activar">
                                                <ButtonItem size="small" verde icon={<CheckOutlined />} onClick={() => this.guardar(m, { activo: true })} />
                                            </Tooltip>
                                        )}
                                    </Space>
                                ),
                            },
                        ]}
                    />
                )}
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({ headersToken: state.user.headersToken });

export default connect(mapStateToProps)(ModalComplementosEmpresa);
